
import {nextTick} from 'vue'
import VirtualScroller from 'components/virtual-scroller'
const ROWS = 4
const ITEM_HEIGHT = 72
const __default__ = {
  components: {VirtualScroller},
  props: {
    uploads: {type: Array, default: () => []},
    expanded: {type: Boolean, default: false},
  },
  emits: ['delete'],
  data() {
    return {
      collapsed: false,
      filter: undefined,
    }
  },
  computed: {
    v_items(){
      if (this.filter === 'failed') {
        return this.failed
      }
      if (this.filter === 'active') {
        return this.active
      }
      return this.uploads
    },
    active() {
      return this.uploads.filter(x => x.started && x.active)
    },
    failed() {
      return this.uploads.filter(x => x.error)
    },
    done() {
      return this.uploads.filter(x => x.result && !x.error)
    },
    height(){
      const height = Math.min(this.v_items.length, ROWS) * ITEM_HEIGHT
      return `${height}px`
    }
  },
  watch: {
    'uploads.length': function (nv, ov) {
      if (nv > ov) {
        this.collapsed = false
        nextTick(() => {
          this.$refs.scroller.scrollTop(65535)
        })
      }
    },
    active(){
      if (this.filter === 'active' && this.active.length === 0) {
        this.filter = undefined
      }
    },
    failed(){
      if (this.filter === 'failed' && this.failed.length === 0) {
        this.filter = undefined
      }
    }
  },
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0f31da72-height": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__